import { useState } from "react";
import ColorPallete from "../../../utils/ColorPallete";
import {useDispatch, useSelector} from 'react-redux';
import EditableInput from "../../../utils/EditableInput";
import {updateElement} from "../../../utils/UpdateFunctions";
import ImageUpload from "../../../utils/ImageUpload";
import { editElement } from "../../../../actions/UserActions";
function TimerElementOptions() {
	const dispatch = useDispatch();
	const {currentCampaignId, currentPage, currentElement} = useSelector(state => state.user);
	const [elementCopy, setElementCopy] = useState(JSON.parse(JSON.stringify(currentElement)));
	const {marginTop, countdown, showTime, timeFontsize, timePadding, timeBackground, label, barHeight, isSticky} = elementCopy;
	const update = (key, value) => {
		if(key === 'timeFontsize') value += 'px';
		else if(key === 'marginTop') value += 'px';
		else if(key === 'timePadding') value += 'px';
		else if(key === 'barHeight') value += 'px';
		else if(key === 'countdown') value *= 1000;
		elementCopy[key] = value;
		updateElement(currentCampaignId, currentPage, elementCopy.id, elementCopy, currentElement, setElementCopy, dispatch, editElement)
	};

	return (
		<div>
			<div className="campaign__option">
				<label className="text--bold">Top Margin (pixels)</label>
				<div className="font--12 text--muted">The space the element has from the top</div>
				<EditableInput item="marginTop" type="number" startValue={(marginTop??'0px').substring(0, marginTop.length - 2)} updateAction={update} placeholder="0" />
			</div>
			<div className="campaign__option">
				<label className="text--bold">Time</label>
				<div className="font--12 text--muted">The time available to answer</div>
				<EditableInput item="countdown" type="number" startValue={countdown/1000} updateAction={update} placeholder="20" min="1" step="1" />
			</div>
			<div className="campaign__option mtop--15">
				<div className="flex flex--row">
					<EditableInput item="showTime" type="checkbox" isSwitch startValue={showTime} updateAction={update} />
					<label className="font--13 text--bold mleft--10">Show the time</label>
				</div>
				<div className="grid grid-cols-2 gap-4">
					<div className="campaign__option">
						<label className="text--bold">Font size (pixels)</label>
						<div className="font--12 text--muted">The font size of the number</div>
						<EditableInput item="timeFontsize" type="number" startValue={timeFontsize.substring(0, timeFontsize.length - 2)} updateAction={update} placeholder="0" />
					</div>
					<div className="campaign__option">
						<label className="text--bold">Time Padding (pixels)</label>
						<div className="font--12 text--muted">The space around the time number</div>
						<EditableInput item="timePadding" type="number" startValue={timePadding.substring(0, timePadding.length - 2)} updateAction={update} placeholder="0" />
					</div>
					<div className="campaign__option col-span-2">
						<label className="text--bold">Image</label>
						<div className="font--12 text--muted">Use a square image for better results</div>
						<ImageUpload campaign_id={currentCampaignId} file={timeBackground} item="timeBackground" updateAction={update} />
					</div>
				</div>
			</div>
			<div className="campaign__option">
				<div className="campaign__option">
					<label className="text--bold">Bar height (pixels)</label>
					<EditableInput item="barHeight" type="number" startValue={barHeight.substring(0, barHeight.length - 2)} updateAction={update} placeholder="0" />
				</div>
			</div>
		</div>
	);
}

export default TimerElementOptions;
